var _Path, _G, _Rect, _Rect2, _Path2, _G2, _G3, _Path3, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, G, Rect, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
function SvgChatAttachment(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M32.03 39.67c-10.81 6.35-24.066 3.585-29.605-6.174-5.54-9.76-1.266-22.818 9.545-29.167C22.78-2.019 36.036.745 41.575 10.505c5.54 9.759 1.266 22.817-9.545 29.166z",
    fill: "#C0E9D3"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#chat-attachment_svg__filter0_d_3072_116450)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M29.313 38.526a1.5 1.5 0 01-1.054.432H10.42a1.71 1.71 0 01-1.71-1.71V5.378c0-.945.765-1.711 1.71-1.711H33.58c.945 0 1.71.766 1.71 1.71v26.62a1.5 1.5 0 01-.446 1.067l-5.532 5.462z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M29.313 38.526a1.5 1.5 0 01-1.054.432H10.42a1.71 1.71 0 01-1.71-1.71V5.378c0-.945.765-1.711 1.71-1.711H33.58c.945 0 1.71.766 1.71 1.71v26.62a1.5 1.5 0 01-.446 1.067l-5.532 5.462z",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  }))), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 9.625,
    y: 35.292,
    width: 20.625,
    height: 2.75,
    rx: 0.478,
    fill: "#C1D4F7"
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    x: 9.61,
    y: 4.572,
    width: 24.781,
    height: 3.62,
    rx: 0.478,
    fill: "#C1D4F7"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M35.063 32.85H30.13c-.567 0-1.027.46-1.027 1.027v4.855l5.959-5.882z",
    fill: "#F6F5F3",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    filter: "url(#chat-attachment_svg__filter1_d_3072_116450)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M21.818 4.643a1.886 1.886 0 00-2.33-1.344l-10.77 2.95a1.938 1.938 0 00-1.36 2.356l1.915 7.306c.059.225.198.42.391.549l5.375 3.57c.227.152.508.197.773.124l7.551-2.07a1.938 1.938 0 001.36-2.354L21.818 4.643z",
    fill: "#FDFAA0"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M21.818 4.643a1.886 1.886 0 00-2.33-1.344l-10.77 2.95a1.938 1.938 0 00-1.36 2.356l1.915 7.306c.059.225.198.42.391.549l5.375 3.57c.227.152.508.197.773.124l7.551-2.07a1.938 1.938 0 001.36-2.354L21.818 4.643z",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  }))), _G3 || (_G3 = /*#__PURE__*/React.createElement(G, {
    filter: "url(#chat-attachment_svg__filter2_d_3072_116450)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12.233 15.733a1 1 0 002 0h-2zm5.208-8.81a1 1 0 10-2 0h2zm-3.208 8.81V6.984h-2v8.749h2zm4.415-8.749v8.845h2V6.984h-2zm-1.207 8.845V6.922h-2v8.907h2zm.071.285a.604.604 0 01-.071-.285h-2c0 .429.106.851.308 1.23l1.763-.945zm1.065 0a.604.604 0 01-1.065 0l-1.763.945c.982 1.831 3.609 1.831 4.59 0l-1.762-.945zm.071-.285c0 .1-.024.197-.071.285l1.762.945c.203-.379.31-.801.31-1.23h-2zm-.215-9.796c.142.297.215.622.215.951h2c0-.627-.14-1.247-.41-1.813l-1.805.862zm-3.985 0c.8-1.675 3.185-1.675 3.985 0l1.804-.862c-1.524-3.193-6.068-3.193-7.593 0l1.804.862zm-.215.951c0-.33.074-.654.215-.951l-1.804-.862a4.207 4.207 0 00-.411 1.813h2z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(G, {
    filter: "url(#chat-attachment_svg__filter3_d_3072_116450)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M13.233 15.733V6.984c0-.478.107-.95.313-1.382v0c1.163-2.434 4.627-2.434 5.789 0v0c.206.431.313.904.313 1.382v8.845c0 .264-.065.524-.19.757v0c-.605 1.129-2.222 1.129-2.827 0v0a1.604 1.604 0 01-.19-.757V6.922",
    stroke: "#C1D4F7",
    strokeLinecap: "round"
  })))), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M14.284 16.5a.944.944 0 00-1.157-.786l-3.369.81 4.997 3.252-.471-3.276z",
    fill: "#FCF871",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
}
export default SvgChatAttachment;